export default {
    Cancel: 'Cancel',
    CheckAll: 'CheckAll',
    Confirm: 'Confirm',
    HasBeenselected: 'selected:',
    NoInformations: 'No relevant information was matched',
    Orgs: 'Departments',
    ResultNum: '',
    SearchOrgUserRole: 'Search Orgnization/User',
    SearchResult: 'result ',
    SelectOrg: 'Select User',
    SelectUser: 'Select Department',
    Subordinate: 'Expand',
    TurnBack: 'back',
    UserAndOrg: 'Select Department/User',
    Users: 'Users',
    SearchOrg: 'Search Organization',
    SearchNameAccount: 'Search Name/Account'
};
